import { GeckoPermsContext } from 'features/permissions/contexts/GeckoPermissionsProvider'
import type { GeckoPermsContextType } from 'features/permissions/types'
import { useContext } from 'react'

export const useGeckoPermissions = (): GeckoPermsContextType => {
  const context = useContext(GeckoPermsContext)
  if (!context)
    throw new Error(
      'useGeckoPermissions() must be used within GeckoPermissionsProvider'
    )
  return context
}
